<div class="category-content">

    <app-contract-advertising-center-group
            [contractOtherCentralAgency]="contractOtherCentralAgencyList[0]">
    </app-contract-advertising-center-group>

    <div class="light-blue-horizontal-separator"></div>


    <app-contract-advertising-center-group
            [contractOtherCentralAgency]="contractOtherCentralAgencyList[1]">
    </app-contract-advertising-center-group>

</div>
